import {
  ApiBlueprint,
  createApiFactory,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import TimelineIcon from '@material-ui/icons/Timeline';
import { productivityApiRef, ProductivityClient } from './api';

const productivityApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: productivityApiRef,
        deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
        factory: ({ discoveryApi, fetchApi }) =>
          new ProductivityClient(discoveryApi, fetchApi),
      }),
    ),
});

const productivityPage = PageBlueprint.make({
  params: {
    path: '/productivity',
    title: 'Productivité',
    // Without an icon, the page gets no sidebar entry
    icon: <TimelineIcon fontSize="inherit" />,
    loader: () =>
      import('./components/ProductivityPage').then(m => <m.ProductivityPage />),
  },
});

/** Ticket opened → first commit → merged into develop, per team (docs/productivity.md). */
export default createFrontendPlugin({
  pluginId: 'productivity',
  icon: <TimelineIcon fontSize="inherit" />,
  extensions: [productivityApi, productivityPage],
});
